import request from '@/utils/request'
import { loginApi } from './requestUrl'

// 预登录
export function preLogin(baseURL, data) {
  return request({
    baseURL,
    url: loginApi.preLogin,
    method: 'post',
    data
  })
}

// 登录
export function login(baseURL, data) {
  return request({
    baseURL,
    url: loginApi.login,
    method: 'post',
    data,
    responseError: false
  })
}

// 找回密码
export function retrievePassword(baseURL, data) {
  return request({
    baseURL,
    url: loginApi.retrievePassword,
    method: 'post',
    data
  })
}

// 重置密码
export function resetPassword(baseURL, data) {
  return request({
    baseURL,
    url: loginApi.resetPassword,
    method: 'post',
    data
  })
}

// 修改密码
export function changePassword(baseURL, data) {
  return request({
    baseURL,
    url: loginApi.changePassword,
    method: 'post',
    data
  })
}

// 获取背景及Logo信息
export function getBrandInfoByDomainName(baseURL, params) {
  return request({
    baseURL,
    url: loginApi.getBrandInfoByDomainName,
    method: 'get',
    params,
    loading: false
  })
}

// 获取第三方登录配置列表
export function getSsoConfig(baseURL, params) {
  return request({
    baseURL,
    url: loginApi.getSsoConfig,
    method: 'get',
    params,
    loading: false
  })
}

// 第三方登录获取租户列表
export function oauthGetTenants(baseURL, data) {
  return request({
    baseURL,
    url: loginApi.oauthGetTenants,
    method: 'post',
    data,
    responseError: false
  })
}
